import { getAccessToken } from "@mindlercare/auth";
import { createClient, RouterTypes } from "@mindlercare/b2b-membership-client";
import { ReactQueryV5 } from "@mindlercare/mindlerapi-client";
const { useQuery } = ReactQueryV5;
import { getCountryCode } from "../helpers/getCountryCode";
import { auth } from "../services/auth";

const getB2BMembershipClient = async () => {
  type Config = Parameters<typeof createClient>[0];
  const clientConfig: Config = {
    jwtToken: await getAccessToken(auth),
  };

  if (import.meta.env.VITE_B2B_MEMBERSHIP_SERVICE_URL) {
    clientConfig.url = import.meta.env.VITE_B2B_MEMBERSHIP_SERVICE_URL;
  } else {
    clientConfig.region = getCountryCode() === "SE" ? "SE" : "XG";
    clientConfig.stage = import.meta.env.VITE_STAGE;
  }

  return createClient(clientConfig);
};

export const useGetMembershipByIdAdmin = (
  membershipId: string,
  { enabled = true }: { enabled?: boolean } = {},
) =>
  useQuery({
    queryKey: ["membershipByIdAdmin", membershipId],
    queryFn: async () => {
      const client = await getB2BMembershipClient();
      return client.getMembershipByIdAdmin.query({
        membershipId,
      } as RouterTypes["getMembershipByIdAdmin"]["input"]);
    },
    enabled: enabled && !!membershipId,
    retry: false,
  });

// Allowed for psychologists, unlike getMembershipByIdAdmin
export const useGetMembershipsByUserId = (
  userId: number,
  { enabled = true }: { enabled?: boolean } = {},
) =>
  useQuery({
    queryKey: ["membershipsByUserId", userId],
    queryFn: async () => {
      const client = await getB2BMembershipClient();
      return client.getMembershipsByUserId.query({
        userId,
      } as RouterTypes["getMembershipsByUserId"]["input"]);
    },
    enabled: enabled && !!userId,
    retry: false,
  });
